var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HTLink"},_vm._l((_vm.linkList),function(link,index){return _c('div',{key:index,on:{"click":function($event){return _vm.ToHT(link.src)}}},[_c('img',{attrs:{"src":link.image,"alt":""}}),_c('span',[_vm._v(_vm._s(link.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }